// jshint module: true

export function getCookie (cname) {
  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export function setCookie (name, value, expiryDays, domain = '*', path = '/') {
  const expiryDate = new Date(new Date().setDate(new Date().getDate() + (expiryDays || 365))).toUTCString()
  const cookie = [`${name}=${value}`]

  cookie.push(`expires=${expiryDate}`)
  cookie.push(`path=${path}`)

  if (domain === '*') {
    const domainParts = window.location.hostname.match(/(.*)([.](.+)[.](.+))/i) || []
    domain = (domainParts.length && domainParts[2] && domainParts[3] && domainParts[3] !== '0') ? domainParts[2] : ''
  }

  if (domain) {
    cookie.push(`domain=${domain}`)
  }

  if (window.location.protocol === 'https:') {
    cookie.push(`secure`)
  }

  cookie.push(`samesite=lax`)

  document.cookie = cookie.join(';')
}
